import { render, staticRenderFns } from "./setvip.vue?vue&type=template&id=1c1538ec&scoped=true"
import script from "./setvip.vue?vue&type=script&lang=js"
export * from "./setvip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1538ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c1538ec')) {
      api.createRecord('1c1538ec', component.options)
    } else {
      api.reload('1c1538ec', component.options)
    }
    module.hot.accept("./setvip.vue?vue&type=template&id=1c1538ec&scoped=true", function () {
      api.rerender('1c1538ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/setvip.vue"
export default component.exports